'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { FaFacebookF, FaArrowRight, FaYoutube, FaInstagram } from 'react-icons/fa';
import NotFound from '@/app/not-found';

const productData = [
  {
    id: 1,
    slug: 'flanged-2-pcs-design',
    title: '2 PIECE Flanged End Ball Valve',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [
      {
        id: 1,
        name: '/images/valve/2-PIECE-Flanged-End-Ball-valve.png',
        type: 'mainImage',
      },
    ],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 2,
    slug: 'flanged-3-pcs-design',
    title: '3-Piece IC Flanged End Ball Valves',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [{ id: 1, name: '/images/valve/3-PIECE-Flanged-End-Ball-Valve.png', type: 'mainImage' }],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 3,
    slug: 'butt-weld-2-pcs-design',
    title: '2-Piece IC Butt Weld End Ball Valve With ISO Mounting Pad',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',

    images: [{ id: 1, name: '/images/valve/butt-weld-3-pcs-design.png', type: 'mainImage' }],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 4,
    slug: 'butt-weld-3-pcs-design',
    title: '3-Piece IC Butt Weld End Ball Valve With ISO Mounting Pad',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [
      {
        id: 1,
        name: '/images/valve/Butt-Weld-End-Ball-Valve-(Size2to8).png',
        type: 'mainImage',
      },
    ],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 5,
    slug: 'screw-socket-2-pcs-design',
    title: '2-Piece IC Screwed / Socket Weld End Ball Valve With ISO Mounting Pad',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [{ id: 1, name: '/images/valve/flanged-end-design-2-to-8.png', type: 'mainImage' }],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 6,
    slug: 'screw-socket-1-pcs-design',
    title: '1-Piece Screwed / Socket Weld End Ball Valve',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [
      { id: 1, name: '/images/valve/screw-socket-1-pcs-design.png', type: 'mainImage' },
    ],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 7,
    slug: 'butt-weld-end-design-2-to-8',
    title: 'Butt Weld End Ball Valve (Size 2" to 8")',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [{ id: 1, name: '/images/valve/butt-weld-2-pcs-design.png', type: 'mainImage' }],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
  {
    id: 8,
    slug: 'flanged-end-design-2-to-8',
    title: 'Flanged End Ball Valve (Size 2" to 8")',
    subtitle: 'Premium quality Ball Valve range from Wonder Valves',
    description:
      'Probably the most popular type of ball valve is the two-piece design. The 2-piece ball valve is ideal for almost any application...',
    images: [{ id: 1, name: '/images/valve/screw-socket-2-pcs-design.png', type: 'mainImage' }],
    designFeatures: [
      { id: 1, label: 'MOC', value: 'WCB/CF8/CF8M/CF3/CF3M And high nickel Alloys, Etc.' },
      { id: 2, label: 'Valve Design', value: 'Two Piece Construction' },
      { id: 3, label: 'Size', value: '15mm to 250mm (1/2" TO 10")' },
      { id: 4, label: 'End Connection', value: 'Flanged End (ASME B16.5)' },
      { id: 5, label: 'Pressure Class', value: '150#' },
      { id: 6, label: 'Operation', value: 'Manual' },
      { id: 7, label: 'Design & Manufacturing Standard', value: 'ISO 17292 / BS 5351 / API 6D' },
      { id: 8, label: 'Testing & Inspection', value: 'API 598 / BS 6755' },
      { id: 9, label: 'Fire Safe', value: 'On Request' },
      { id: 10, label: 'Valve Bore', value: 'Full Bore' },
      { id: 11, label: 'Face to Face', value: 'ASME B16.10' },
      { id: 12, label: 'Temp. Range', value: '-20 TO 180°C' },
    ],
    technicalSpecifications: [
      {
        id: 1,
        description: 'Body',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      {
        id: 2,
        description: 'Tail Piece',
        material: 'ASTM A216 Gr. WCB / ASTM A351 Gr. CF8/CF8M/CF3/CF3M',
      },
      { id: 3, description: 'Ball (Hollow/Solid)', material: 'ASTM A351 Gr. CF8/CF8M/CF3/CF3M' },
      { id: 4, description: 'Seat Ring', material: 'PTFE/GFT/CFT/TFM' },
      { id: 5, description: 'Body Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 6, description: 'Stem Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 7, description: 'Gland Seal', material: 'PTFE/GFT/CFT/TFM/GRAFOIL' },
      { id: 8, description: 'Gland', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 9, description: 'Lock Nut', material: 'SS202/SS304/SS316/MS' },
      { id: 10, description: 'Stem', material: 'SS304/SS316/SS304L/SS316L/SS410' },
      { id: 11, description: 'Handle', material: 'SS202/SS304/SS316/CS' },
      { id: 12, description: 'Sleeve', material: 'PVC' },
      { id: 13, description: 'Bolt', material: 'SS202/SS304/SS316/B7/MS' },
    ],
    benefits: [
      { id: 'benefit1', text: 'Full port – higher flow rates & No Pressure Drops' },
      { id: 'benefit2', text: 'Blowout-proof Stem Design' },
      { id: 'benefit3', text: 'Anti Static Device (On Request)' },
      { id: 'benefit4', text: 'Less joint – Chance of low leakage' },
      { id: 'benefit5', text: 'Fire Safe Design (On Request)' },
      { id: 'benefit6', text: 'More economical than 3-piece Design' },
      { id: 'benefit7', text: 'Low cost compared to other full port options' },
    ],
    testingParameters: [
      { id: 'test1', testType: 'Hydro. Shell', unit: '32', psig: '430' },
      { id: 'test2', testType: 'Hydro. Seat', unit: '22', psig: '315' },
      { id: 'test3', testType: 'Air/Pneumatic', unit: '7', psig: '80' },
    ],
  },
];

const socialLinks = [
  { icon: FaFacebookF, url: 'https://facebook.com' },
  { icon: FaInstagram, url: 'https://instagram.com' },
  { icon: FaYoutube, url: 'https://youtube.com' },
];

interface ProductPageProps {
  params: {
    slug: string;
  };
}

// const iconMap: Record<string, JSX.Element> = {
//   facebook: <FaFacebookF className="cursor-pointer hover:scale-110 transition" />,
//   linkedin: <FaLinkedinIn className="cursor-pointer hover:scale-110 transition" />,
//   twitter: <FaTwitter className="cursor-pointer hover:scale-110 transition" />,
//   whatsapp: <FaWhatsapp className="cursor-pointer hover:scale-110 transition" />,
// };

const ProductDetail = ({ params }: ProductPageProps) => {
  const router = useRouter();
  const product = productData.find((p) => p.slug === params.slug);

  if (!product) return <NotFound data-component-id="src/app/products/[slug]/page.tsx:530:23" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="530" data-component-file="page.tsx" data-component-name="NotFound" data-component-content="%7B%22elementName%22%3A%22NotFound%22%7D" />;

  return (
    <div data-component-id="src/app/products/[slug]/page.tsx:533:4" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="533" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-sans%20text-gray-800%20bg-white%20px-4%20sm%3Apx-6%20lg%3Apx-24%20py-10%20lg%3Apy-16%20max-w-screen-xl%20mx-auto%22%7D" className="font-sans text-gray-800 bg-white px-4 sm:px-6 lg:px-24 py-10 lg:py-16 max-w-screen-xl mx-auto">
      {/* Back Button */}
      <button data-component-id="src/app/products/[slug]/page.tsx:535:6" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="535" data-component-file="page.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22mb-6%20inline-flex%20items-center%20text-sm%20font-medium%20text-primaryColor%20hover%3Aunderline%20gap-2%22%2C%22textContent%22%3A%22Back%22%7D"
        onClick={() => router.back()}
        className="mb-6 inline-flex items-center text-sm font-medium text-primaryColor hover:underline gap-2"
      >
        <IoMdArrowRoundBack data-component-id="src/app/products/[slug]/page.tsx:539:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="539" data-component-file="page.tsx" data-component-name="IoMdArrowRoundBack" data-component-content="%7B%22elementName%22%3A%22IoMdArrowRoundBack%22%2C%22className%22%3A%22text-xl%22%7D" className="text-xl" />
        Back
      </button>

      {/* Header */}
      <div data-component-id="src/app/products/[slug]/page.tsx:544:6" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="544" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%20flex%20flex-col%20sm%3Aflex-row%20justify-between%20gap-4%22%7D" className="mb-6 flex flex-col sm:flex-row justify-between gap-4">
        <div data-component-id="src/app/products/[slug]/page.tsx:545:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="545" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h1 data-component-id="src/app/products/[slug]/page.tsx:546:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="546" data-component-file="page.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-3xl%20font-bold%20text-primaryColor%22%7D" className="text-3xl font-bold text-primaryColor">{product.title}</h1>
          <p data-component-id="src/app/products/[slug]/page.tsx:547:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="547" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22italic%20text-sm%20text-gray-500%22%7D" className="italic text-sm text-gray-500">{product.subtitle}</p>
        </div>
        <div data-component-id="src/app/products/[slug]/page.tsx:549:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="549" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20space-x-3%20mt-5%22%7D" className="flex space-x-3 mt-5">
          {socialLinks.map((social, index) => (
            <div data-component-id="src/app/products/[slug]/page.tsx:551:12" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="551" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-10%20h-10%20bg-white%2F10%20rounded-full%20flex%20items-center%20justify-center%20hover%3Abg-white%2F20%20transition%22%7D"
              key={index}
              className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition"
            >
              <a data-component-id="src/app/products/[slug]/page.tsx:555:14" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="555" data-component-file="page.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-primaryColor%20text-base%22%7D" href={social.url} className="text-primaryColor text-base">
                {social.icon({ className: 'w-5 h-5' })}
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Description */}
      <p data-component-id="src/app/products/[slug]/page.tsx:564:6" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="564" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mb-10%20text-base%20sm%3Atext-lg%20text-gray-700%22%7D" className="mb-10 text-base sm:text-lg text-gray-700">{product.description}</p>

      {/* Image */}
      <div data-component-id="src/app/products/[slug]/page.tsx:567:6" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="567" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-12%20group%22%7D" className="mb-12 group">
        {product.images?.length > 0 ? (
          <Image data-component-id="src/app/products/[slug]/page.tsx:569:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="569" data-component-file="page.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20sm%3Aw-%5B350px%5D%20md%3Aw-%5B400px%5D%20lg%3Aw-%5B500px%5D%20xl%3Aw-%5B600px%5D%20h-64%20sm%3Ah-80%20md%3Ah-%5B400px%5D%20lg%3Ah-%5B500px%5D%20xl%3Ah-%5B600px%5D%20max-w-xl%20mx-auto%20object-contain%20transform%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
            src={product.images[0].name}
            alt={product.title ?? 'Product image'}
            width={800}
            height={600}
            className="w-full sm:w-[350px] md:w-[400px] lg:w-[500px] xl:w-[600px] h-64 sm:h-80 md:h-[400px] lg:h-[500px] xl:h-[600px] max-w-xl mx-auto object-contain transform transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div data-component-id="src/app/products/[slug]/page.tsx:577:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="577" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20sm%3Aw-%5B350px%5D%20md%3Aw-%5B400px%5D%20lg%3Aw-%5B500px%5D%20xl%3Aw-%5B600px%5D%20h-64%20sm%3Ah-80%20md%3Ah-%5B400px%5D%20lg%3Ah-%5B500px%5D%20xl%3Ah-%5B600px%5D%20max-w-xl%20bg-gray-100%20flex%20items-center%20justify-center%20text-gray-500%20mx-auto%22%2C%22textContent%22%3A%22No%20image%20available%22%7D" className="w-full sm:w-[350px] md:w-[400px] lg:w-[500px] xl:w-[600px] h-64 sm:h-80 md:h-[400px] lg:h-[500px] xl:h-[600px] max-w-xl bg-gray-100 flex items-center justify-center text-gray-500 mx-auto">
            No image available
          </div>
        )}
      </div>

      {/* Grid Sections */}
      <div data-component-id="src/app/products/[slug]/page.tsx:584:6" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="584" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-2%20gap-8%20text-sm%20text-gray-700%22%7D" className="grid grid-cols-1 lg:grid-cols-2 gap-8 text-sm text-gray-700">
        {/* Design Features */}
        <div data-component-id="src/app/products/[slug]/page.tsx:586:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="586" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h2 data-component-id="src/app/products/[slug]/page.tsx:587:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="587" data-component-file="page.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-bold%20text-primaryColor%20mb-4%22%2C%22textContent%22%3A%22Design%20Features%22%7D" className="text-xl font-bold text-primaryColor mb-4">Design Features</h2>
          <table data-component-id="src/app/products/[slug]/page.tsx:588:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="588" data-component-file="page.tsx" data-component-name="table" data-component-content="%7B%22elementName%22%3A%22table%22%2C%22className%22%3A%22w-full%20text-sm%20text-gray-700%22%7D" className="w-full text-sm text-gray-700">
            <tbody data-component-id="src/app/products/[slug]/page.tsx:589:12" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="589" data-component-file="page.tsx" data-component-name="tbody" data-component-content="%7B%22elementName%22%3A%22tbody%22%7D">
              {product.designFeatures.map((data, index) => (
                <tr data-component-id="src/app/products/[slug]/page.tsx:591:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="591" data-component-file="page.tsx" data-component-name="tr" data-component-content="%7B%22elementName%22%3A%22tr%22%2C%22className%22%3A%22border-b%22%7D" key={index} className="border-b">
                  <td data-component-id="src/app/products/[slug]/page.tsx:592:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="592" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22py-1%20pr-4%20font-semibold%20w-48%22%7D" className="py-1 pr-4 font-semibold w-48">{data.label}</td>
                  <td data-component-id="src/app/products/[slug]/page.tsx:593:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="593" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22py-1%22%7D" className="py-1">{data.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Technical Specs */}
        <div data-component-id="src/app/products/[slug]/page.tsx:601:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="601" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h2 data-component-id="src/app/products/[slug]/page.tsx:602:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="602" data-component-file="page.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-bold%20text-primaryColor%20mb-4%22%2C%22textContent%22%3A%22Technical%20Specifications%22%7D" className="text-xl font-bold text-primaryColor mb-4">Technical Specifications</h2>
          <div data-component-id="src/app/products/[slug]/page.tsx:603:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="603" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22overflow-x-auto%22%7D" className="overflow-x-auto">
            <table data-component-id="src/app/products/[slug]/page.tsx:604:12" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="604" data-component-file="page.tsx" data-component-name="table" data-component-content="%7B%22elementName%22%3A%22table%22%2C%22className%22%3A%22w-full%20min-w-%5B400px%5D%20text-left%20border%20border-gray-300%20text-xs%22%7D" className="w-full min-w-[400px] text-left border border-gray-300 text-xs">
              <thead data-component-id="src/app/products/[slug]/page.tsx:605:14" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="605" data-component-file="page.tsx" data-component-name="thead" data-component-content="%7B%22elementName%22%3A%22thead%22%2C%22className%22%3A%22bg-gray-100%22%7D" className="bg-gray-100">
                <tr data-component-id="src/app/products/[slug]/page.tsx:606:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="606" data-component-file="page.tsx" data-component-name="tr" data-component-content="%7B%22elementName%22%3A%22tr%22%7D">
                  <th data-component-id="src/app/products/[slug]/page.tsx:607:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="607" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22No.%22%7D" className="p-2 border">No.</th>
                  <th data-component-id="src/app/products/[slug]/page.tsx:608:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="608" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22Description%22%7D" className="p-2 border">Description</th>
                  <th data-component-id="src/app/products/[slug]/page.tsx:609:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="609" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22Material%22%7D" className="p-2 border">Material</th>
                </tr>
              </thead>
              <tbody data-component-id="src/app/products/[slug]/page.tsx:612:14" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="612" data-component-file="page.tsx" data-component-name="tbody" data-component-content="%7B%22elementName%22%3A%22tbody%22%7D">
                {product.technicalSpecifications.map((data, index) => (
                  <tr data-component-id="src/app/products/[slug]/page.tsx:614:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="614" data-component-file="page.tsx" data-component-name="tr" data-component-content="%7B%22elementName%22%3A%22tr%22%2C%22className%22%3A%22border-t%22%7D" key={index} className="border-t">
                    <td data-component-id="src/app/products/[slug]/page.tsx:615:20" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="615" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{data.id}</td>
                    <td data-component-id="src/app/products/[slug]/page.tsx:616:20" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="616" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{data.description}</td>
                    <td data-component-id="src/app/products/[slug]/page.tsx:617:20" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="617" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{data.material}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Benefits */}
        <div data-component-id="src/app/products/[slug]/page.tsx:626:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="626" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h2 data-component-id="src/app/products/[slug]/page.tsx:627:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="627" data-component-file="page.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-bold%20text-primaryColor%20mb-4%22%2C%22textContent%22%3A%22Benefits%20%26%20Applications%22%7D" className="text-xl font-bold text-primaryColor mb-4">Benefits & Applications</h2>
          <div data-component-id="src/app/products/[slug]/page.tsx:628:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="628" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" className="space-y-2">
            {product.benefits.map((data, index) => (
              <div data-component-id="src/app/products/[slug]/page.tsx:630:14" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="630" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-2%20text-gray-700%22%7D" key={data.id} className="flex items-start gap-2 text-gray-700">
                <FaArrowRight data-component-id="src/app/products/[slug]/page.tsx:631:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="631" data-component-file="page.tsx" data-component-name="FaArrowRight" data-component-content="%7B%22elementName%22%3A%22FaArrowRight%22%2C%22className%22%3A%22text-primaryColor%20mt-1%20shrink-0%22%7D" className="text-primaryColor mt-1 shrink-0" />
                <p data-component-id="src/app/products/[slug]/page.tsx:632:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="632" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%22%7D" className="text-sm">{data.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Testing */}
        <div data-component-id="src/app/products/[slug]/page.tsx:639:8" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="639" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h2 data-component-id="src/app/products/[slug]/page.tsx:640:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="640" data-component-file="page.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-bold%20text-primaryColor%20mb-4%22%2C%22textContent%22%3A%22Testing%20Parameters%22%7D" className="text-xl font-bold text-primaryColor mb-4">Testing Parameters</h2>
          <table data-component-id="src/app/products/[slug]/page.tsx:641:10" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="641" data-component-file="page.tsx" data-component-name="table" data-component-content="%7B%22elementName%22%3A%22table%22%2C%22className%22%3A%22min-w-full%20text-left%20border%20border-gray-300%20text-sm%22%7D" className="min-w-full text-left border border-gray-300 text-sm">
            <thead data-component-id="src/app/products/[slug]/page.tsx:642:12" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="642" data-component-file="page.tsx" data-component-name="thead" data-component-content="%7B%22elementName%22%3A%22thead%22%2C%22className%22%3A%22bg-gray-100%22%7D" className="bg-gray-100">
              <tr data-component-id="src/app/products/[slug]/page.tsx:643:14" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="643" data-component-file="page.tsx" data-component-name="tr" data-component-content="%7B%22elementName%22%3A%22tr%22%7D">
                <th data-component-id="src/app/products/[slug]/page.tsx:644:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="644" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22Test%20Type%22%7D" className="p-2 border">Test Type</th>
                <th data-component-id="src/app/products/[slug]/page.tsx:645:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="645" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22Unit-Kg%20%2F%20Cm%C2%B2%22%7D" className="p-2 border">Unit-Kg / Cm²</th>
                <th data-component-id="src/app/products/[slug]/page.tsx:646:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="646" data-component-file="page.tsx" data-component-name="th" data-component-content="%7B%22elementName%22%3A%22th%22%2C%22className%22%3A%22p-2%20border%22%2C%22textContent%22%3A%22PSIG%22%7D" className="p-2 border">PSIG</th>
              </tr>
            </thead>
            <tbody data-component-id="src/app/products/[slug]/page.tsx:649:12" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="649" data-component-file="page.tsx" data-component-name="tbody" data-component-content="%7B%22elementName%22%3A%22tbody%22%7D">
              {product.testingParameters.map((t, i) => (
                <tr data-component-id="src/app/products/[slug]/page.tsx:651:16" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="651" data-component-file="page.tsx" data-component-name="tr" data-component-content="%7B%22elementName%22%3A%22tr%22%2C%22className%22%3A%22border-t%22%7D" key={i} className="border-t">
                  <td data-component-id="src/app/products/[slug]/page.tsx:652:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="652" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{t.testType}</td>
                  <td data-component-id="src/app/products/[slug]/page.tsx:653:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="653" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{t.unit}</td>
                  <td data-component-id="src/app/products/[slug]/page.tsx:654:18" data-component-path="src/app/products/[slug]/page.tsx" data-component-line="654" data-component-file="page.tsx" data-component-name="td" data-component-content="%7B%22elementName%22%3A%22td%22%2C%22className%22%3A%22p-2%20border%22%7D" className="p-2 border">{t.psig}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
